var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pa-4" },
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          "footer-props": { itemsPerPageOptions: [10, 25] },
          items: _vm.accounts,
          loading: _vm.loading,
          "loading-text": "Loading... Please wait",
        },
        scopedSlots: _vm._u([
          {
            key: "footer.page-text",
            fn: function (props) {
              return [
                _vm._v(
                  " " +
                    _vm._s(props.pageStart) +
                    "-" +
                    _vm._s(props.pageStop) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.OwnerEmail",
            fn: function ({ item }) {
              return [
                _vm._v(" " + _vm._s(_vm.getAccountOwnerEmail(item)) + " "),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { color: "action-button-color" },
                        on: {
                          click: function ($event) {
                            return _vm.viewMachines(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-tractor ")]
                    ),
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: {
                          color: "error-button-color",
                          disabled: item.AccountId.startsWith("00000000-"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.confirmDeleteAccount(item)
                          },
                        },
                      },
                      [_vm._v(" mdi-delete ")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "footer.prepend",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.newAccountDialog = true
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("create_new_account_and_owner")) + " "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", persistent: "" },
          model: {
            value: _vm.newAccountDialog,
            callback: function ($$v) {
              _vm.newAccountDialog = $$v
            },
            expression: "newAccountDialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(" Add New Account "),
              ]),
              _c(
                "v-form",
                {
                  staticClass: "pa-5",
                  model: {
                    value: _vm.newAccountFormValid,
                    callback: function ($$v) {
                      _vm.newAccountFormValid = $$v
                    },
                    expression: "newAccountFormValid",
                  },
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      label: "Account Name",
                      rules: [() => !!_vm.newAccountName || "Required"],
                    },
                    model: {
                      value: _vm.newAccountName,
                      callback: function ($$v) {
                        _vm.newAccountName = $$v
                      },
                      expression: "newAccountName",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      label: "Account Description",
                      rules: [() => !!_vm.newAccountDescription || "Required"],
                    },
                    model: {
                      value: _vm.newAccountDescription,
                      callback: function ($$v) {
                        _vm.newAccountDescription = $$v
                      },
                      expression: "newAccountDescription",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      label: "Account Owner Email",
                      rules: [() => !!_vm.newAccountDescription || "Required"],
                    },
                    model: {
                      value: _vm.newAccountOwnerEmail,
                      callback: function ($$v) {
                        _vm.newAccountOwnerEmail = $$v
                      },
                      expression: "newAccountOwnerEmail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.newAccountDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: !_vm.newAccountFormValid },
                      on: {
                        click: function ($event) {
                          return _vm.createNewAccountAndOwner()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("save")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.deleteDialog
        ? _c("deleteAccount", {
            attrs: { account: _vm.deleteAccountItem },
            on: { update: _vm.initialize },
            model: {
              value: _vm.deleteDialog,
              callback: function ($$v) {
                _vm.deleteDialog = $$v
              },
              expression: "deleteDialog",
            },
          })
        : _vm._e(),
      _c(
        "v-overlay",
        {
          attrs: { opacity: 0.5, value: _vm.creatingAccount, "z-index": "300" },
        },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "42" },
          }),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "primary", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackBar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackBar,
            callback: function ($$v) {
              _vm.snackBar = $$v
            },
            expression: "snackBar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackBarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }